var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "wrapper", class: _vm.bemBlock }, [
    _c(
      "ul",
      {
        directives: [{ name: "drag-scroll", rawName: "v-drag-scroll" }],
        ref: "list",
        class: _vm.bemElement("list")
      },
      _vm._l(_vm.siblingMenu, function(category, index) {
        return _c(
          "li",
          { key: index, class: _vm.bemElement("item") },
          [
            _c(
              "BaseLink",
              {
                class: [
                  _vm.bemElement("link"),
                  { "router-link-active": _vm.isSelected(category) }
                ],
                attrs: { url: category.url },
                on: {
                  click: function($event) {
                    return _vm.handleClick(category)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(category.name) + "\n      ")]
            )
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }